import { render, staticRenderFns } from "./profile-menu.vue?vue&type=template&id=921792c8"
import script from "./profile-menu.vue?vue&type=script&lang=js"
export * from "./profile-menu.vue?vue&type=script&lang=js"
import style0 from "./profile-menu.vue?vue&type=style&index=0&id=921792c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports